import type { RoleView } from './model/types';
export const ROLE_MODULE_ORDERS: Record<RoleView, string[]> = {
  investmentManager: [
    'highlights',
    'tasks',
    'schedule',
    'focus',
    'risks',
    'activities',
    'quickActions',
    'businessApps',
  ],
  partner: [
    'highlights',
    'risks',
    'tasks',
    'focus',
    'schedule',
    'activities',
    'quickActions',
    'businessApps',
  ],
  fundraising: [
    'focus',
    'tasks',
    'schedule',
    'highlights',
    'activities',
    'risks',
    'quickActions',
    'businessApps',
  ],
  portfolio: [
    'risks',
    'focus',
    'tasks',
    'schedule',
    'activities',
    'highlights',
    'quickActions',
    'businessApps',
  ],
  exit: [
    'highlights',
    'tasks',
    'schedule',
    'focus',
    'risks',
    'activities',
    'quickActions',
    'businessApps',
  ],
  research: [
    'activities',
    'focus',
    'tasks',
    'schedule',
    'highlights',
    'risks',
    'quickActions',
    'businessApps',
  ],
};
